import React, { useState, useEffect, useRef } from 'react';
import { collection, getDocs, addDoc } from "firebase/firestore";
import { db } from "../firebase";
import emailjs from '@emailjs/browser';
import SimpleSlider from './SimpleSlider'; // Adjust path as needed




const HeatPumpQuoteCalculator = () => {
 // State management
 const topRef = useRef(null);
 const [loading, setLoading] = useState(true);
 const [error, setError] = useState(null);
 const [availableModels, setAvailableModels] = useState([]);
 const [selectedModel, setSelectedModel] = useState(null);
 const [products, setProducts] = useState({
   highWall: { Mitsubishi: [], Daikin: [] },
   ducted: { Mitsubishi: [], Daikin: [] },
   ventilation: []
 });
  // Add this function to find available models for the customer's requirements
const findAvailableModels = (capacity, type, brand) => {
 // Get all units of the correct type and brand
 const units = type === 'highWall' ? products.highWall[brand] : products.ducted[brand];
  if (!units || units.length === 0) return [];
  // Filter units that meet or exceed the required capacity
 // We'll consider units within a reasonable range (e.g., up to 30% more than required)
 const maxCapacity = capacity * 1.1
  const suitableUnits = units.filter(unit =>
   unit.heatingCapacity >= capacity && unit.heatingCapacity <= maxCapacity
 );
  // If no units within ideal range, get the closest ones
 if (suitableUnits.length === 0) {
   const sortedUnits = [...units].sort((a, b) =>
     Math.abs(a.heatingCapacity - capacity) - Math.abs(b.heatingCapacity - capacity)
   );
  
   // Return top 1 closest models
   return sortedUnits.slice(0,1);
 }
  return suitableUnits;
};


 // Step navigation
 const [step, setStep] = useState(1);



  // User selections
 const [quoteType, setQuoteType] = useState('');
 const [roomInfo, setRoomInfo] = useState({
   width: 4,
   length: 5,
   height: 2.4,
   roomVolume: 48,
   insulation: 1
 });
 const [multiRoomInfo, setMultiRoomInfo] = useState({
   bedrooms: 2,
   livingArea: 30,
   insulation: 1
 });
 const [brandPreference, setBrandPreference] = useState('');
 const [wifiControl, setWifiControl] = useState(false);
 const [selectedVentilation, setSelectedVentilation] = useState(null);
  // Results
 const [requiredCapacity, setRequiredCapacity] = useState(0);
 const [selectedUnit, setSelectedUnit] = useState(null);
 const [quote, setQuote] = useState(null);
  // Form data
 const [contactInfo, setContactInfo] = useState({
   name: '',
   email: '',
   phone: '',
   address: '',
   comments: ''
 });
 // Refresh Step 4 once after 0.5s when step 4 becomes active
useEffect(() => {
 let timeout;
 if (step === 4 && quoteType !== 'ventilation') {
   timeout = setTimeout(() => {
     const capacity = calculateHeatingCapacity();
     setRequiredCapacity(capacity);
     const models = findSuitableModels(capacity, quoteType, brandPreference);
     setAvailableModels(models);
     const uniqueModels = models.filter(
      (u, i, arr) => arr.findIndex(x => x.id === u.id) === i
    );
    
    setAvailableModels(uniqueModels);
     console.log('Step 4 initialized after delay');
   }, 500);
 }
 return () => clearTimeout(timeout);
}, [step, quoteType, brandPreference, products]);


//Effect to scroll user to top of view
useEffect(() => {
  // Scroll the calculator container
  if (topRef.current) {
    topRef.current.scrollIntoView();
  }
  // Scroll window, body, and html for all browsers
  setTimeout(() => {
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }, 50);
}, [step]);
  
  // Scroll window
 // window.scrollTo({ top: 0, behavior: 'smooth' });
  // Scroll body and html for mobile browsers
 // document.body.scrollTop = 0;
 // document.documentElement.scrollTop = 0;
//}, [step]);




 // Effect to update room volume when dimensions change
 useEffect(() => {
   const volume = roomInfo.width * roomInfo.length * roomInfo.height;
   setRoomInfo(prev => ({...prev, roomVolume: volume}));
 }, [roomInfo.width, roomInfo.length, roomInfo.height]);
  // Load product data on component mount
 console.log("Component rendering...");
 console.log("Products data structure:", products);
 useEffect(() => {
   console.log("useEffect triggered!");
   const loadProducts = async () => {
     console.log("loadProducts function called!");
       try {
         setLoading(true);
        
         console.log("Attempting to connect to Firebase...");
        
         // Get products from Firestore
         const productsSnapshot = await getDocs(collection(db, "products"));
         console.log("Query successful, retrieved documents:", productsSnapshot.size);
        
         const productsList = productsSnapshot.docs.map(doc => ({
           id: doc.id,
           ...doc.data()
         }));
        
         console.log("First product:", productsList[0] || "No products found");
        
         // Process the data
         const processedData = processProductData(productsList);
         setProducts(processedData);
         setLoading(false);
       } catch (err) {
         console.error("Error loading products:", err);
         console.error("Error details:", err.code, err.message);
         setError("Failed to load product data. Please try again later.");
         setLoading(false);
       }
     };
  
   loadProducts();
 }, []);


 const processProductData = (data) => {
  console.log('⚙️ processProductData called with', data.length, 'items');
  const buckets = {
    highWall:    { Mitsubishi: [], Daikin: [] },
    ducted:      { Mitsubishi: [], Daikin: [] },
    ventilation: []
  };

  data.forEach(item => {
    console.log('📦 Raw item:', item);
    const typeRaw  = (item.Type  || '').toLowerCase().trim();
    const brandRaw = (item.Brand || '').toLowerCase().trim();

    let price = parseFloat(item.Price);
    if (isNaN(price)) price = 0;

    let heatingCapacity = null;
    if (item.HeatingCapacity) {
      const m = String(item.HeatingCapacity).match(/(\d+(\.\d+)?)/);
      heatingCapacity = m ? parseFloat(m[1]) : null;
    }

    let coolingCapacity = null;
const ccRaw = item.CoolingCapacity ?? item.coolingcapacity ?? null;
if (ccRaw) {
  const m2 = String(ccRaw).match(/(\d+(?:\.\d+)?)/);
  coolingCapacity = m2 ? parseFloat(m2[1]) : null;
}

    const product = {
      brand: item.Brand || item.brand || '',
      id:          item.Code || item.id || '',
      code:        item.Code || '',
      title:       item.ShortDescription || '',
      description: item.ShortDescription || '',
      features:    item.Features || '',
      price,
      heatingCapacity,
      coolingCapacity,
      hasWifi:     Boolean(item.hasWifi),
      image:       item.Image || ''
    };
    if (typeRaw.includes('high wall')) {
      if (brandRaw.includes('mitsubishi')) buckets.highWall.Mitsubishi.push(product);
      else if (brandRaw.includes('daikin'))   buckets.highWall.Daikin.push(product);
    }
    if (typeRaw === 'high wall') {
      if (brandRaw.includes('mitsubishi')) buckets.highWall.Mitsubishi.push(product);
      else if (brandRaw.includes('daikin'))  buckets.highWall.Daikin.push(product);
    }
    else if (typeRaw === 'ducted') {
      if (brandRaw.includes('mitsubishi')) buckets.ducted.Mitsubishi.push(product);
      else if (brandRaw.includes('daikin'))  buckets.ducted.Daikin.push(product);
    }
    else if (typeRaw === 'ventilation') {
      buckets.ventilation.push(product);
    }
    else {
      console.warn(`⚠️ Unmatched type/brand: ${item.Type} / ${item.Brand}`);
    }
  });

  console.log('✅ Product counts:', {
    highWallMitsubishi: buckets.highWall.Mitsubishi.length,
    highWallDaikin:     buckets.highWall.Daikin.length,
    ductedMitsubishi:   buckets.ducted.Mitsubishi.length,
    ductedDaikin:       buckets.ducted.Daikin.length,
    ventilation:        buckets.ventilation.length
  });

  return buckets;
};
 /*
 // Process CSV data into structured format
 const processProductData = (data) => {
   const highWallMitsubishi = [];
   const highWallDaikin = [];
   const ductedMitsubishi = [];
   const ductedDaikin = [];
   const ventilation = [];
  
   // Process each product
   data.forEach(item => {
     const title = item["Item title"] || "";
     const description = item["Long description"] || "";
     const fullText = title + " " + description;
    
     // Determine product type
     let type = "other";
     if (fullText.toLowerCase().includes("ventilation")) {
       type = "ventilation";
     } else if (fullText.toLowerCase().includes("high wall") ||
               fullText.toLowerCase().includes("highwall") ||
               fullText.toLowerCase().includes("wall mounted")) {
       type = "high wall";
     } else if (fullText.toLowerCase().includes("ducted")) {
       type = "ducted";
     } else if ((fullText.toLowerCase().includes("heat pump") ||
                fullText.toLowerCase().includes("heatpump")) &&
               !fullText.toLowerCase().includes("ducted")) {
       type = "high wall"; // Default to high wall for standard heat pumps
     }
    
     // Determine brand
     const isMitsubishi = fullText.includes("Mitsubishi");
     const isDaikin = fullText.includes("Daikin");
    
     // Extract heating capacity
     let heatingCapacity = null;
     const heatingMatch = description.match(/(\d+\.\d+|\d+)[\s]*kW heating capacity/i);
     if (heatingMatch) {
       heatingCapacity = parseFloat(heatingMatch[1]);
     } else {
       const match = fullText.match(/(\d+\.\d+|\d+)[\s]*kW/i);
       if (match) {
         heatingCapacity = parseFloat(match[1]);
       }
     }
    
     // Extract price
     let price = 0;
     try {
       if (item["Unit price"]) {
         price = parseFloat(item["Unit price"].replace(/[^\d.-]/g, '')) || 0;
       }
     } catch (e) {
       console.error('Price parsing error:', e);
     }
    
     // Check if it has WiFi
     const hasWifi = fullText.toLowerCase().includes("wifi") ||
                    fullText.toLowerCase().includes("wi-fi");
    
     // Create product object
     const product = {
       id: item["Item ÏĐ"] || `id-${Math.random().toString(36).substring(2, 9)}`,
       code: item["Item code"] || "",
       title,
       description,
       price,
       heatingCapacity,
       hasWifi
     };
    
     // Add to appropriate category
     if (type === "high wall" && isMitsubishi && price > 0 && heatingCapacity > 0) {
       highWallMitsubishi.push(product);
     } else if (type === "high wall" && isDaikin && price > 0 && heatingCapacity > 0) {
       highWallDaikin.push(product);
     } else if (type === "ducted" && isMitsubishi && price > 0 && heatingCapacity > 0) {
       ductedMitsubishi.push(product);
     } else if (type === "ducted" && isDaikin && price > 0 && heatingCapacity > 0) {
       ductedDaikin.push(product);
     } else if (type === "ventilation" && price > 0) {
       ventilation.push(product);
     }
   });
  
   // Add default items if needed
   if (highWallMitsubishi.length === 0) {
     highWallMitsubishi.push({
       id: "default-hw-m",
       title: "Mitsubishi Electric Heat Pump",
       description: "Standard high wall heat pump",
       price: 2500,
       heatingCapacity: 3.5,
       hasWifi: false
     });
   }
  
   if (highWallDaikin.length === 0) {
     highWallDaikin.push({
       id: "default-hw-d",
       title: "Daikin Heat Pump",
       description: "Standard high wall heat pump",
       price: 2300,
       heatingCapacity: 3.2,
       hasWifi: false
     });
   }
  
   if (ductedMitsubishi.length === 0) {
     ductedMitsubishi.push({
       id: "default-d-m",
       title: "Mitsubishi Electric Ducted System",
       description: "Standard ducted heat pump system",
       price: 7000,
       heatingCapacity: 7.1,
       hasWifi: false
     });
   }
  
   if (ductedDaikin.length === 0) {
     ductedDaikin.push({
       id: "default-d-d",
       title: "Daikin Ducted System",
       description: "Standard ducted heat pump system",
       price: 5800,
       heatingCapacity: 7.0,
       hasWifi: false
     });
   }
  
   if (ventilation.length === 0) {
     ventilation.push({
       id: "default-vent",
       title: "Home Ventilation System",
       description: "Standard home ventilation system",
       price: 3500,
       hasWifi: false
     });
   }
  
   return {
     highWall: {
       Mitsubishi: highWallMitsubishi,
       Daikin: highWallDaikin
     },
     ducted: {
       Mitsubishi: ductedMitsubishi,
       Daikin: ductedDaikin
     },
     ventilation
   };
 };
 */
 // Calculate heating capacity based on room information
 const calculateHeatingCapacity = () => {
   if (quoteType === 'single') {
     // (room volume / 20) * insulation level
     const volume = roomInfo.roomVolume;
     const insulation = parseFloat(roomInfo.insulation);
     return (volume / 20) * insulation;
   } else if (quoteType === 'multi') {
     // Total area = (bedrooms * 12m²) + living area
     // Volume = area * 2.4m (ceiling height)
     const bedrooms = parseInt(multiRoomInfo.bedrooms) || 0;
     const livingArea = parseFloat(multiRoomInfo.livingArea) || 0;
     const insulation = parseFloat(multiRoomInfo.insulation);
    
     const totalArea = (bedrooms * 12) + livingArea;
     const volume = totalArea * 2.4;
     return (volume / 20) * insulation;
   }
   return 0;
 };
 const findSuitableModels = (capacity, type, brand) => {
  if (!capacity || capacity <= 0 || !brand) return [];
  const bucket = type === 'single' ? 'highWall' : 'ducted';
  const units = products[bucket]?.[brand] || [];

  // Only units at or above required capacity, up to +30%
  const lowerBound = capacity;
  const upperBound = capacity * 1.2
  let suitableUnits = units.filter(u =>
    u.heatingCapacity >= lowerBound && u.heatingCapacity <= upperBound
  );

  // Fallback: pick the three closest ABOVE capacity (ignore anything below)
  if (suitableUnits.length === 0) {
    suitableUnits = units
      .filter(u => u.heatingCapacity >= capacity)
      .sort((a, b) => a.heatingCapacity - b.heatingCapacity)
      .slice(0, 3);
  }

  return suitableUnits;
};


 // Find a suitable unit based on capacity requirements
 const findSuitableUnit = (capacity, type, brand) => {
   const units = type === 'highWall' ? products.highWall[brand] : products.ducted[brand];
  
   if (!units || units.length === 0) return null;
  
   // Sort by capacity
   const sortedUnits = [...units].sort((a, b) => a.heatingCapacity - b.heatingCapacity);
  
   // Find first unit that meets or exceeds required capacity
   const suitableUnit = sortedUnits.find(unit => unit.heatingCapacity >= capacity);
  
   // Return suitable unit or largest available if none meets requirements
   return suitableUnit || sortedUnits[sortedUnits.length - 1];
 };
  // Calculate final price
 const calculateFinalPrice = (unit) => {
   if (!unit) return 0;
  
   let price = unit.price;
  
   // Add WiFi if selected and not already included
   if (wifiControl && !unit.hasWifi) {
     price += 150;
   }
  
   return price;
 };
  // Handle next step button
 const handleNext = () => {
   // Validate current step
   if (step === 1 && !quoteType) {
     alert('Please select a space type');
     return;
   }
  
   if (step === 3) {
     if (quoteType === 'ventilation') {
       if (!selectedVentilation) {
         alert('Please select a ventilation system');
         return;
       }
     } else if (!brandPreference) {
       alert('Please select a brand preference');
       return;
     }
   }
  
   //new logic
   if (step === 4 && quoteType !== 'ventilation') {
     // Calculate required capacity
     const capacity = calculateHeatingCapacity();
     setRequiredCapacity(capacity);
    
     // Find available models
     const type = quoteType === 'single' ? 'highWall' : 'ducted';
     const models = findAvailableModels(capacity, type, brandPreference);
     setAvailableModels(models);
    
     // If there's only one model, select it automatically
     if (models.length === 1) {
       setSelectedModel(models[0]);
       setSelectedUnit(models[0]);
      
       // Create heat pump quote
       const finalPrice = calculateFinalPrice(models[0]);
       setQuote({
         type: quoteType,
         unit: models[0],
         capacity,
         wifiControl,
         price: finalPrice
       });
      
       setStep(6); // Skip to contact info
     } else {
       // Multiple models available, go to model selection step
       setStep(5); // This will be our new model selection step
     }
   } else if (step === 5 && selectedModel) {
     // User has selected a model, set it as the selected unit
     setSelectedUnit(selectedModel);
    
     // Create heat pump quote
     const finalPrice = calculateFinalPrice(selectedModel);
     setQuote({
       type: quoteType,
       unit: selectedModel,
       capacity: requiredCapacity,
       wifiControl,
       price: finalPrice
     });
    
     setStep(6); // Go to quote results
   }
  


   // Special handling for step transitions
   if (step === 1 && quoteType === 'ventilation') {
     // Skip step 2 for ventilation
     setStep(3);
   } else if (step === 3 && quoteType === 'ventilation') {
     // Create ventilation quote
     setQuote({
       type: 'ventilation',
       system: selectedVentilation,
       price: selectedVentilation.price
     });
     setStep(5); // Skip to contact info
   } else if (step === 4 && quoteType !== 'ventilation') {
     // Calculate required capacity
     const capacity = calculateHeatingCapacity();
     setRequiredCapacity(capacity);
    
     // Find suitable unit
     const type = quoteType === 'single' ? 'highWall' : 'ducted';
     const unit = findSuitableUnit(capacity, type, brandPreference);
     setSelectedUnit(unit);
    
     // Create heat pump quote
     if (unit) {
       const finalPrice = calculateFinalPrice(unit);
       setQuote({
         type: quoteType,
         unit,
         capacity,
         wifiControl,
         price: finalPrice
       });
     }
    
     setStep(step + 1);
   } else {
     // Regular step progression
     setStep(step + 1);
   }
 };
  // Handle back button
 const handleBack = () => {
  if (step === 4 && quoteType !== 'ventilation') {
    setAvailableModels([]);    // clear the list
    setSelectedModel(null);    // clear any selection
  }
   if (step === 3 && quoteType === 'ventilation') {
     setStep(1); // Go back to step 1 from ventilation selection
   } else {
     setStep(step - 1);
   }
 };
  // Handle form submission


 const handleSubmit = async () => {
   if (!contactInfo.name || !contactInfo.email || !contactInfo.phone) {
     alert("Please fill in all required fields");
     return;
   }
  
   try {
     // Add quote to Firestore
     await addDoc(collection(db, "quotes"), {
       quoteType,
       contactInfo,
       selectedUnitId: selectedModel ? selectedModel.title : null,
       selectedVentilationId: selectedVentilation ? selectedVentilation.title : null,
       wifiControl,
       requiredCapacity: requiredCapacity || 0,
       totalPrice: calculateFinalPrice(selectedModel),
       timestamp: new Date()
     });


    // Prepare data for EmailJS
   const templateParams = {
     to_name: "Bay Breeze Heat Pumps", // Change to your company name
     from_name: contactInfo.name,
     from_email: contactInfo.email,
     from_phone: contactInfo.phone,
     from_address: contactInfo.address || "Not provided",
     comments: contactInfo.comments || "No additional comments",
     quote_type: quoteType,
     product: selectedModel ? selectedModel.title : (selectedVentilation ? selectedVentilation.title : "Not selected"),
     price: calculateFinalPrice(selectedModel).toFixed(2),
     wifi_control: wifiControl ? "Yes" : "No",
    // quote_id: docRef.id
   };
  
   // Send email using EmailJS
   await emailjs.send(
     'service_cjzmvzg', // Replace with your EmailJS service ID
     'template_obgdsr2', // Replace with your EmailJS template ID
     templateParams,
     '0MqcNJnUX1WV90xmq' // Replace with your EmailJS user ID
   );


     // Show confirmation
     setStep(7);
   } catch (err) {
     alert("There was an error submitting your quote. Please try again.");
     console.error(err);
   }
 };
 const Slider = ({ min, max, step, value, onChange, label, unit }) => (
   <div className="mb-6">
     <div className="flex justify-between items-center mb-2">
       <label className="text-gray-300 text-sm">{label}</label>
       <span className="text-gray-300 font-medium">{value} {unit}</span>
     </div>
     <input
       type="range"
       min={min}
       max={max}
       step={step}
       value={value}
       onChange={onChange}
       className="w-full h-2 bg-gray-700 rounded-lg appearance-none cursor-pointer accent-primary hover:accent-primary-light focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2 focus:ring-offset-gray-800"
     />
     <div className="flex justify-between text-xs text-gray-500 mt-1">
       <span>{min} {unit}</span>
       <span>{max} {unit}</span>
     </div>
   </div>
 );
 const sortedModels = [...availableModels].sort((a, b) => a.price - b.price);

 // Render loading state
 if (loading) {
   return (
     <div className="min-h-screen bg-gray-900 flex items-center justify-center text-white">
       <div className="bg-gray-800 p-8 rounded-lg shadow-lg text-center max-w-md">
         <h1 className="text-2xl font-bold mb-4 text-primary-light">Heat Pump Quote Calculator</h1>
         <p className="mb-4 text-gray-300">Loading product data...</p>
         <div className="w-full h-2 bg-gray-700 rounded-full overflow-hidden">
           <div className="bg-primary h-full animate-pulse"></div>
         </div>
       </div>
     </div>
   );
 }
  // Render error state
 if (error) {
   return (
     <div className="min-h-screen bg-gray-900 flex items-center justify-center text-white">
       <div className="bg-gray-800 p-8 rounded-lg shadow-lg text-center max-w-md">
         <h1 className="text-2xl font-bold mb-4 text-primary-light">Heat Pump Quote Calculator</h1>
         <div className="text-red-400 mb-4">
           <svg className="w-16 h-16 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
             <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
           </svg>
           <p>{error}</p>
         </div>
         <button
           className="bg-primary text-white px-4 py-2 rounded hover:bg-primary-dark transition"
           onClick={() => window.location.reload()}
         >
           Try Again
         </button>
       </div>
     </div>
   );
 }
  return (
   <div ref={topRef} className="min-h-screen bg-slate-950/0 p-4 text-gray-200">
     <div className="max-w-3xl mx-auto">
       <div className="text-center mb-8">
         <h1 className="text-3xl font-bold text-primary-light mb-1">Heat Pump Quote Calculator</h1>
         <p className="text-gray-400">Get an instant online quote for your heat pump installation</p>
       </div>
      
       {/* Progress bar */}
       {step < 7 && (
         <div className="mb-8">
           <div className="h-2 bg-gray-800 rounded-full overflow-hidden">
             <div
               className="h-full bg-primary transition-all duration-300"
               style={{ width: `${(step / 7) * 100}%` }}
             ></div>
           </div>
           <div className="flex justify-between mt-2 text-xs text-gray-500">
             <span>Start</span>
             <span>Details</span>
             <span>Brand</span>
             <span>Options</span>
             <span>Quote</span>
             <span>Contact</span>
           </div>
         </div>
       )}
      
       {/* Step 1: Select Space Type */}
       {step === 1 && (
         <div className="bg-gray-800 p-6 rounded-lg shadow-lg">
           <h2 className="text-xl font-semibold mb-6 text-primary-light">What type of space do you want to heat or cool?</h2>
           <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
             <div
               className={`p-6 border rounded-lg cursor-pointer transition transform hover:scale-105 duration-200 ${quoteType === 'single' ? 'border-primary bg-gray-700' : 'border-gray-700 hover:border-primary-light'}`}
               onClick={() => { setQuoteType('single'); setStep(2); }}
             >
               <div className="text-center mb-4">
                 <img src="https://firebasestorage.googleapis.com/v0/b/calculator-61aa0.firebasestorage.app/o/Highwall.png?alt=media&token=d00f6d62-ce7f-483a-bbcc-9c3f3a7e2545" alt="High Wall" />
               </div>
               <h3 className="font-medium text-center text-lg">A Single Room</h3>
               <p className="text-sm text-gray-400 text-center mt-2">High wall heat pump option</p>
             </div>
            
             <div
               className={`p-6 border rounded-lg cursor-pointer transition transform hover:scale-105 duration-200 ${quoteType === 'multi' ? 'border-primary bg-gray-700' : 'border-gray-700 hover:border-primary-light'}`}
               onClick={() => { setQuoteType('multi'); setStep(2); }
                
              }
              
             >
               <div className="text-center mb-4">
                  <img src="https://firebasestorage.googleapis.com/v0/b/calculator-61aa0.firebasestorage.app/o/Ducted.png?alt=media&token=95b7e834-10ce-4014-9939-ad87e61c1183" alt="Ducted System" />
               </div>
               <h3 className="font-medium text-center text-lg">Multiple Rooms or Whole Home</h3>
               <p className="text-sm text-gray-400 text-center mt-2">Ducted heat pump option</p>
             </div>
      {/*
             <div
               className={`p-6 border rounded-lg cursor-pointer transition transform hover:scale-105 duration-200 ${quoteType === 'ventilation' ? 'border-primary bg-gray-700' : 'border-gray-700 hover:border-primary-light'}`}
               onClick={() => setQuoteType('ventilation')}
             >
               <div className="text-center mb-4">
                 <svg className="w-16 h-16 mx-auto text-primary-light" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M14.828 14.828a4 4 0 01-5.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                 </svg>
               </div>
               <h3 className="font-medium text-center text-lg">Ventilation System</h3>
               <p className="text-sm text-gray-400 text-center mt-2">Fresh air ventilation option</p>
             </div>
            */} 
           </div>
         </div>
       )}
    
       {/* Step 2: Room Details */}
       {step === 2 && quoteType === 'single' && (
         <div className="bg-gray-800 p-6 rounded-lg shadow-lg">
           <h2 className="text-xl font-semibold mb-6 text-primary-light">Single Room Details</h2>
          
           <SimpleSlider
             min={2}
             max={10}
             step={0.1}
             value={roomInfo.width}
             onChange={e => setRoomInfo({...roomInfo, width: parseFloat(e.target.value)})}
             label="Room Width"
             unit="m"
           />
          
           <SimpleSlider
             min={2}
             max={15}
             step={0.1}
             value={roomInfo.length}
             onChange={e => setRoomInfo({...roomInfo, length: parseFloat(e.target.value)})}
             label="Room Length"
             unit="m"
           />
          
           <SimpleSlider
             min={2}
             max={4}
             step={0.1}
             value={roomInfo.height}
             onChange={e => setRoomInfo({...roomInfo, height: parseFloat(e.target.value)})}
             label="Room Height"
             unit="m"
           />
          
           <div className="bg-gray-700 p-4 rounded-lg mb-6">
             <div className="flex justify-between">
               <span className="text-gray-300">Room Volume:</span>
               <span className="text-white font-semibold">{roomInfo.roomVolume.toFixed(1)} m³</span>
             </div>
           </div>
          
           <div className="mb-4">
             <label className="block text-gray-300 mb-2">How well insulated is your home?</label>
             <div className="grid grid-cols-3 gap-3">
               <div
                 className={`border p-3 rounded-lg text-center cursor-pointer transition ${roomInfo.insulation === .9 ? 'border-primary bg-gray-700' : 'border-gray-700'}`}
                 onClick={() => setRoomInfo({...roomInfo, insulation: .9})}
               >
                 <div className="text-xl mb-1">🔥</div>
                 <div className="font-medium">Great</div>
                 <div className="text-xs text-gray-400">Well Insulated</div>
               </div>
               <div
                 className={`border p-3 rounded-lg text-center cursor-pointer transition ${roomInfo.insulation === 1.1 ? 'border-primary bg-gray-700' : 'border-gray-700'}`}
                 onClick={() => setRoomInfo({...roomInfo, insulation: 1.1})}
               >
                 <div className="text-xl mb-1">❄️</div>
                 <div className="font-medium">Average</div>
                 <div className="text-xs text-gray-400">Some Insulation</div>
               </div>
               <div
                 className={`border p-3 rounded-lg text-center cursor-pointer transition ${roomInfo.insulation === 1.3 ? 'border-primary bg-gray-700' : 'border-gray-700'}`}
                 onClick={() => setRoomInfo({...roomInfo, insulation: 1.3})}
               >
                 <div className="text-xl mb-1">🥶</div>
                 <div className="font-medium">Poor</div>
                 <div className="text-xs text-gray-400">No Insulation</div>
               </div>
             </div>
           </div>
         </div>
       )}
      
       {step === 2 && quoteType === 'multi' && (
         <div className="bg-gray-800 p-6 rounded-lg shadow-lg">
           <h2 className="text-xl font-semibold mb-6 text-primary-light">Multi-Room or Whole Home Details</h2>
          
           <SimpleSlider
             min={1}
             max={8}
             step={1}
             value={multiRoomInfo.bedrooms}
             onChange={e => setMultiRoomInfo({...multiRoomInfo, bedrooms: parseInt(e.target.value)})}
             label="How many bedrooms / offices do you want to heat or cool?"
             unit="rooms"
           />
           <p className="text-sm text-gray-400 mb-6 -mt-5">Each bedroom is assumed to be 12m²</p>
          
           <SimpleSlider
             min={10}
             max={150}
             step={1}
             value={multiRoomInfo.livingArea}
             onChange={e => setMultiRoomInfo({...multiRoomInfo, livingArea: parseInt(e.target.value)})}
             label="What is the size of your living area to heat and cool?"
             unit="m²"
           />
          
           <div className="bg-gray-700 p-4 rounded-lg mb-6">
             <div className="flex justify-between">
               <span className="text-gray-300">Total Area:</span>
               <span className="text-white font-semibold">{(parseInt(multiRoomInfo.bedrooms) * 12 + parseInt(multiRoomInfo.livingArea)).toFixed(0)} m²</span>
             </div>
           </div>
          
           <div className="mb-4">
             <label className="block text-gray-300 mb-2">How well insulated is your home?</label>
             <div className="grid grid-cols-3 gap-3">
               <div
                 className={`border p-3 rounded-lg text-center cursor-pointer transition ${multiRoomInfo.insulation === 0.9 ? 'border-primary bg-gray-700' : 'border-gray-700'}`}
                 onClick={() => setMultiRoomInfo({...multiRoomInfo, insulation: 0.9})}
               >
                 <div className="text-xl mb-1">🔥</div>
                 <div className="font-medium">Great</div>
                 <div className="text-xs text-gray-400">Well Insulated</div>
               </div>
               <div
                 className={`border p-3 rounded-lg text-center cursor-pointer transition ${multiRoomInfo.insulation === 1.1 ? 'border-primary bg-gray-700' : 'border-gray-700'}`}
                 onClick={() => setMultiRoomInfo({...multiRoomInfo, insulation: 1.1})}
               >
                 <div className="text-xl mb-1">❄️</div>
                 <div className="font-medium">Average</div>
                 <div className="text-xs text-gray-400">Some Insulation</div>
               </div>
               <div
                 className={`border p-3 rounded-lg text-center cursor-pointer transition ${multiRoomInfo.insulation === 1.3 ? 'border-primary bg-gray-700' : 'border-gray-700'}`}
                 onClick={() => setMultiRoomInfo({...multiRoomInfo, insulation: 1.3})}
               >
                 <div className="text-xl mb-1">🥶</div>
                 <div className="font-medium">Poor</div>
                 <div className="text-xs text-gray-400">No Insulation</div>
               </div>
             </div>
           </div>
         </div>
       )}
      
       {/* Step 3: Brand Selection or Ventilation Options */}
       {step === 3 && quoteType !== 'ventilation' && (
         <div className="bg-gray-800 p-6 rounded-lg shadow-lg">
           <h2 className="text-xl font-semibold mb-6 text-primary-light">Choose Your Preferred Brand</h2>
           <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
             <div
               className={`p-6 border rounded-lg cursor-pointer transition transform hover:scale-105 duration-200 ${brandPreference === 'Mitsubishi' ? 'border-primary bg-gray-700' : 'border-gray-700 hover:border-primary-light'}`}
               onClick={() => setBrandPreference('Mitsubishi')}
             >
               <div className="text-center mb-4">
               <img src="https://firebasestorage.googleapis.com/v0/b/calculator-61aa0.firebasestorage.app/o/mitsubishiElectricLogo.png?alt=media&token=a0c263c5-3b6e-434c-9f3d-28b74ec2d62a" alt="Mitsubishi Electric" />
               </div>
               <h3 className="font-medium text-center text-lg">Mitsubishi Electric</h3>
               <p className="text-sm text-gray-400 text-center mt-2">Premium quality and reliability</p>
             </div>
            
             <div
               className={`p-6 border rounded-lg cursor-pointer transition transform hover:scale-105 duration-200 ${brandPreference === 'Daikin' ? 'border-primary bg-gray-700' : 'border-gray-700 hover:border-primary-light'}`}
               onClick={() => setBrandPreference('Daikin')}
             >
               <div className="text-center mb-4">
               <img src="https://firebasestorage.googleapis.com/v0/b/calculator-61aa0.firebasestorage.app/o/daikinLogo.png?alt=media&token=676f3671-2ab8-43f6-a9f1-303b66a08792" alt="Daikin" />
               </div>
               <h3 className="font-medium text-center text-lg">Daikin</h3>
               <p className="text-sm text-gray-400 text-center mt-2">Innovative technology and design</p>
             </div>
           </div>
         </div>
       )}
      
       {step === 3 && quoteType === 'ventilation' && (
         <div className="bg-gray-800 p-6 rounded-lg shadow-lg">
           <h2 className="text-xl font-semibold mb-6 text-primary-light">Ventilation Options</h2>
           <p className="mb-4 text-gray-300">Choose from our available ventilation systems:</p>
          
           <div className="space-y-4">
             {products.ventilation.map((system, index) => (
               <div
                 key={system.id}
                 className={`p-4 border rounded-lg cursor-pointer transition transform hover:scale-105 duration-200 ${selectedVentilation === system ? 'border-primary bg-gray-700' : 'border-gray-700 hover:border-primary-light'}`}
                 onClick={() => setSelectedVentilation(system)}
               >
                 <div className="flex justify-between items-center">
                   <div>
                     <h3 className="font-medium text-lg">{system.title}</h3>
                     <p className="text-sm text-gray-400 mt-1">{system.description ? system.description.substring(0, 100) + (system.description.length > 100 ? '...' : '') : 'Standard ventilation system'}</p>
                   </div>
                   <div className="text-primary-light font-bold text-xl">${system.price.toFixed(2)}</div>
                 </div>
               </div>
             ))}
           </div>
         </div>
       )}
      {/* Step 4: Additional Options (For heat pumps only) */}
{step === 4 && quoteType !== 'ventilation' && (
 <div className="bg-gray-800 p-6 rounded-lg shadow-lg">
   <h2 className="text-xl font-semibold mb-6 text-primary-light">Additional Options</h2>
  
   <div className="bg-gray-700 p-5 rounded-lg mb-6">
     <h3 className="font-medium mb-3 text-gray-300">Required Heating Capacity</h3>
     <div className="text-3xl font-bold text-primary-light flex items-baseline">
       {calculateHeatingCapacity().toFixed(2)} <span className="text-sm ml-1 text-gray-300">kW</span>
     </div>
     <p className="text-sm text-gray-400 mt-2">Based on your room specifications and insulation level</p>
   </div>
  
   {/* WiFi Control Option - Now as a separate section */}
   <div className="border border-gray-700 p-5 rounded-lg hover:border-primary-light transition cursor-pointer mb-6">
     <label className="flex items-center">
       <input
         type="checkbox"
         className="w-5 h-5 text-primary rounded"
         checked={wifiControl}
         onChange={(e) => setWifiControl(e.target.checked)}
       />
       <div className="ml-3">
         <span className="text-lg font-medium block">Add WiFi Control</span>
         <span className="text-primary-light font-bold">$150.00</span>
         <p className="text-sm text-gray-400 mt-1">Control your heat pump from anywhere using your smartphone, monitor energy usage and set timers & schedules.</p>
       </div>
     </label>
   </div>
  
  {/* Model Selection - Now as a separate section */}


<div className="mt-8">
  <h3 className="text-lg font-semibold mb-4 text-primary-light">Select a Model</h3>

  <div className="bg-gray-700 p-4 rounded-lg mb-6">
    <div className="flex justify-between items-center">
      <span className="text-gray-300">Required Capacity:</span>
      <span className="text-primary-light font-semibold">
        {requiredCapacity.toFixed(2)} kW
      </span>
    </div>
    <div className="flex justify-between items-center mt-2">
      <span className="text-gray-300">Brand:</span>
      <span className="text-gray-200 font-semibold">{brandPreference}</span>
    </div>
  </div>

  <p className="mb-4 text-gray-300">
    Please select from the available models that meet your requirements:
  </p>

  <div className="space-y-4">
  
  {sortedModels.map(model => (
      <div
        key={model.id}
        className={`border p-4 rounded-lg cursor-pointer transition ${
          selectedModel?.id === model.id
            ? 'border-primary bg-gray-700'
            : 'border-gray-700 hover:border-primary-light'
        }`}
        onClick={() => setSelectedModel(model)}
      >
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center">
          {/* Text block */}
          <div className="mb-3 md:mb-0">
            <h3 className="font-medium text-lg">
              {model.brand} {model.code}
            </h3>
            <p className="text-sm text-gray-400 mt-1">
              {model.features
                ? model.features.slice(0, 100) +
                  (model.features.length > 100 ? '…' : '')
                : 'Energy‑efficient heat pump'}
            </p>
            <div className="mt-2 text-primary-light">
              <span className="font-semibold">
                {model.heatingCapacity?.toFixed(1)} kW
              </span>
              <span className="text-gray-400 ml-2">Heating Capacity</span>
            </div>
            <div className="mt-2 text-primary-light">
              <span className="font-semibold">
                {model.coolingCapacity?.toFixed(1)} kW
              </span>
              <span className="text-gray-400 ml-2">Cooling Capacity</span>
            </div>
            {model.hasWifi && (
              <div className="mt-1 text-green-400 text-sm">
                ✓ Built‑in WiFi
              </div>
            )}
            <div className="mt-1 text-primary-light font-bold">
              Installed from: ${model.price.toFixed(2)}
            </div>
          </div>

          {/* Image */}
          {model.image && (
            <img
              src={model.image}
              alt={model.title}
              className="w-64 h-auto object-contain self-end md:self-auto"
            />
          )}
        </div>
      </div>
    ))}


      
       {availableModels.length === 0 && (
         <div className="text-center py-6 text-gray-400">
           <svg className="w-12 h-12 mx-auto text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
             <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
           </svg>
           <p className="mt-2">No models available that match your requirements.</p>
           <p className="mt-1">Please adjust your room dimensions or contact us for a custom quote.</p>
         </div>
       )}
     </div>
   </div>
 </div>
)}
{/* Step 5: Quote Results */}
{step === 5 && (
         <div className="bg-gray-800 p-6 rounded-lg shadow-lg">
           <h2 className="text-xl font-semibold mb-6 text-primary-light">
             {quoteType === 'ventilation' ? 'Your Ventilation Quote' : 'Your Heat Pump Quote'}
           </h2>
          
           <div className="border border-gray-700 rounded-lg overflow-hidden mb-2">
             {/* Quote Image */}
             <div className="bg-gray-700 p-5 mb-6">
               <img src={selectedModel.image} alt="System" className="mx-auto rounded-lg w-300px" />
             </div>
            
             {/* Quote Details */}
             <div className="p-6">
               {quote && quote.type === 'ventilation' && selectedVentilation && (
                 <>
                   <h3 className="font-medium text-xl text-gray-100 mb-2">{selectedVentilation.title}</h3>
                   <p className="text-gray-400 my-4">{selectedVentilation.description || 'Standard ventilation system for improved air quality'}</p>
                  
                   <div className="border-t border-gray-700 pt-4 mt-6">
                     <div className="flex justify-between mb-2">
                       <span className="text-gray-400">System Price:</span>
                       <span className="text-gray-200">${selectedVentilation.price.toFixed(2)}</span>
                     </div>
                    
                     <div className="text-2xl font-bold mt-4 text-primary-light flex justify-between items-center">
                       <span>Total:</span>
                       <span>${selectedVentilation.price.toFixed(2)}</span>
                     </div>
                   </div>
                 </>
               )}
              
               {quote && (quote.type === 'single' || quote.type === 'multi') && selectedModel && (
                 <>
                   <h3 className="font-medium text-xl text-gray-100 mb-2">{selectedModel.title}</h3>
                   <p className="text-gray-400 my-4">{selectedModel.features || 'Energy-efficient heat pump system'}</p>
                  
                   <div className="bg-gray-700 p-3 rounded-lg mb-4">
                     <div className="flex justify-between items-center">
                       <span className="text-gray-300">Required Capacity:</span>
                       <span className="text-primary-light font-semibold">{requiredCapacity.toFixed(2)} kW</span>
                     </div>
                     <div className="flex justify-between items-center mt-2">
                       <span className="text-gray-300">Unit Capacity:</span>
                       <span className="text-gray-200 font-semibold">{selectedModel.heatingCapacity.toFixed(2)} kW</span>
                     </div>
                   </div>
                  
                   <div className="border-t border-gray-700 pt-4">
                     <div className="flex justify-between mb-2">
                       <span className="text-gray-400">Base Price:</span>
                       <span className="text-gray-200">${selectedModel.price.toFixed(2)}</span>
                     </div>
                     {wifiControl && !selectedModel.hasWifi && (
                       <div className="flex justify-between mb-2">
                         <span className="text-gray-400">WiFi Control:</span>
                         <span className="text-gray-200">$150.00</span>
                       </div>
                     )}
                     {selectedModel.hasWifi && (
                       <div className="flex justify-between mb-2">
                         <span className="text-gray-400">Built-in WiFi:</span>
                         <span className="text-green-400">Included</span>
                       </div>
                     )}
                    
                     <div className="text-2xl font-bold mt-4 text-primary-light flex justify-between items-center">
                       <span>Total:</span>
                       <span>${calculateFinalPrice(selectedModel).toFixed(2)}</span>
                     </div>
                   </div>
                 </>
               )}
             </div>
           </div>
          
           <p className="text-gray-400">To book a free in home quote and confirm the calculator results, please fill out your contact details on the next page.</p>
         </div>
       )}
      
      
       {/* Step 6: Contact Information */}
       {step === 6 && (
         <div className="bg-gray-800 p-6 rounded-lg shadow-lg">
           <h2 className="text-xl font-semibold mb-6 text-primary-light">Contact Information</h2>
           <div className="space-y-5">
             <div>
               <label className="block text-gray-300 mb-1">Full Name *</label>
               <input
                 type="text"
                 className="w-full p-3 border border-gray-700 rounded-lg bg-gray-900 text-white focus:outline-none focus:border-primary"
                 placeholder="Enter your full name"
                 value={contactInfo.name}
                 onChange={(e) => setContactInfo({...contactInfo, name: e.target.value})}
                 required
               />
             </div>
            
             <div>
               <label className="block text-gray-300 mb-1">Email Address *</label>
               <input
                 type="email"
                 className="w-full p-3 border border-gray-700 rounded-lg bg-gray-900 text-white focus:outline-none focus:border-primary"
                 placeholder="Enter your email address"
                 value={contactInfo.email}
                 onChange={(e) => setContactInfo({...contactInfo, email: e.target.value})}
                 required
               />
             </div>
            
             <div>
               <label className="block text-gray-300 mb-1">Phone Number *</label>
               <input
                 type="tel"
                 className="w-full p-3 border border-gray-700 rounded-lg bg-gray-900 text-white focus:outline-none focus:border-primary"
                 placeholder="Enter your phone number"
                 value={contactInfo.phone}
                 onChange={(e) => setContactInfo({...contactInfo, phone: e.target.value})}
                 required
               />
             </div>
            
             <div>
               <label className="block text-gray-300 mb-1">Address *</label>
               <input
                 type="text"
                 className="w-full p-3 border border-gray-700 rounded-lg bg-gray-900 text-white focus:outline-none focus:border-primary"
                 placeholder="Enter your address"
                 value={contactInfo.address}
                 onChange={(e) => setContactInfo({...contactInfo, address: e.target.value})}
                 required
               />
             </div>
            
             <div>
               <label className="block text-gray-300 mb-1">Additional Comments</label>
               <textarea
                 className="w-full p-3 border border-gray-700 rounded-lg bg-gray-900 text-white focus:outline-none focus:border-primary"
                 placeholder="Any additional information you'd like to share"
                 rows="3"
                 value={contactInfo.comments}
                 onChange={(e) => setContactInfo({...contactInfo, comments: e.target.value})}
               ></textarea>
             </div>
           </div>
         </div>
       )}
      
      




       {/* Step 7: Confirmation */}
       {step === 7 && (
         <div className="bg-gray-800 p-8 rounded-lg shadow-lg text-center">
           <div className="text-green-400 mb-4">
             <svg className="w-20 h-20 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
               <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
             </svg>
           </div>
           <h2 className="text-2xl font-semibold mb-4 text-primary-light">Thank You!</h2>
           <p className="mb-4 text-gray-300">Your quote request has been submitted successfully.</p>
           <p className="mb-8 text-gray-400">Our team will get back to you within 24 hours to discuss your installation.</p>
           <button
             className="px-8 py-3 bg-primary text-white rounded-lg hover:bg-primary-dark transition transform hover:scale-105 duration-200"
             onClick={() => {
               // Reset and start over
               setStep(1);
               setQuoteType('');
               setRoomInfo({
                 width: 4,
                 length: 5,
                 height: 2.4,
                 roomVolume: 48,
                 insulation: 1
               });
               setMultiRoomInfo({
                 bedrooms: 2,
                 livingArea: 30,
                 insulation: 1
               });
               setBrandPreference('');
               setWifiControl(false);
               setSelectedVentilation(null);
               setRequiredCapacity(0);
               setSelectedUnit(null);
               setSelectedModel(null);
               setQuote(null);
               setAvailableModels(null);
               setContactInfo({
                 name: '',
                 email: '',
                 phone: '',
                 address: '',
                 comments: ''
               });
             }}
           >
             Get Another Quote
           </button>
         </div>
       )}
      
       {/* Navigation Buttons */}
       {step < 7 && (
         <div className="flex justify-between mt-8">
           {step > 1 ? (
             <button
               className="px-5 py-2 bg-gray-700 text-gray-300 rounded-lg hover:bg-gray-600 transition"
               onClick={handleBack}
             >
               Back
             </button>
           ) : (
             <div></div>
           )}
          
           <button
             className="px-6 py-3 bg-primary text-white rounded-lg hover:bg-primary-dark transition transform hover:scale-105 duration-200"
             onClick={step === 6 ? handleSubmit : handleNext}
           >
             {step === 6 ? 'Submit' : 'Next'}
           </button>
         </div>
       )}
     </div>
   </div>
 );
};


export default HeatPumpQuoteCalculator;

